export const topologyColors = {
  white: "#ffffff",
  gray300: "#dee0e5",
  gray400: "#abb0b7",
  gray500: "#8c8e91",
  gray700: "#4f5155",
  blue500: "#25ace7",
  warning: "#FA9301",
};
